@if (errorTransformationLogItem?.errorCode === 'REFERENZERTRAG_WEA_INVALID') {
  <span>
    In der Spalte <i>{{ formatArray(errorTransformationLogItem.columnNames) }}</i> wird eine natürliche Zahl erwartet.
  </span>
}

@if (errorTransformationLogItem?.errorCode === 'UNPARSEABLE_BIGDECIMAL' || errorTransformationLogItem?.errorCode ==='UNPARSEABLE_INTEGER') {
  <span
    >
    In der Spalte <i>{{ formatArray(errorTransformationLogItem.columnNames) }}</i> wird statt <i>{{ errorTransformationLogItem.objects }}</i> ein Zahlwert erwartet.
  </span>
}

@if (errorTransformationLogItem?.errorCode === 'UNPARSEABLE_DATE') {
  <span>
    In der Spalte <i>{{ formatArray(errorTransformationLogItem.columnNames) }}</i> wird statt <i>{{ errorTransformationLogItem.objects }}</i> ein Datum erwartet.
  </span>
}

@if (errorTransformationLogItem?.errorCode === 'NETZZUORDNUNG_UNKNOWN') {
  <span>
    Die Werte in den Spalten <i>{{ formatArray(errorTransformationLogItem.columnNames) }}</i> können keiner validen Netzzuordnung im
    Leitsystem zugeordnet werden. Gültige Kombinationen können im TNB-Portal eingesehen werden, wenn Sie in der Detailansicht eines Erzeugers den Abschnitt 'Netzzuordnung' die jeweiligen Dropdown-Listen auswählen.
  </span>
}

@if (errorTransformationLogItem?.errorCode === 'ENERGIETRAEGER_UNKNOWN') {
  <span>
    In der Spalte <i>{{ formatArray(errorTransformationLogItem.columnNames) }}</i> ist der Wert <i>{{ errorTransformationLogItem.objects }}</i> kein valider Energieträger. Bitte verwenden Sie nur Werte aus der Auswahlliste.
  </span>
}

@if (errorTransformationLogItem?.errorCode === 'ANSCHRIFT_PLZ_EMPTY') {
  <span>
    Für die Spalte <i>{{ formatArray(errorTransformationLogItem.columnNames) }}</i> kann kein Wert ermittelt werden.
  </span>
}

@if (errorTransformationLogItem?.errorCode === 'ANSCHRIFT_GEMEINDE_EMPTY') {
  <span>
    Für die Spalte <i>{{ formatArray(errorTransformationLogItem.columnNames) }}</i> kann kein Wert ermittelt werden.
  </span>
}

@if (errorTransformationLogItem?.errorCode === 'BLINDLEISTUNGSVERFAHREN_NOT_FOUND') {
  <span>
    In den Spalten <i>{{ formatArray(errorTransformationLogItem.columnNames) }}</i> ist der Wert <i>{{ errorTransformationLogItem.objects }}</i> kein valides Blindleistungsverfahren. Bitte verwenden Sie nur Werte aus der Auswahlliste.
  </span>
}

@if (errorTransformationLogItem?.errorCode === 'GEOKOORDINATENSSYSTEM_NOT_FOUND') {
  <span>
    In der Spalte <i>{{ formatArray(errorTransformationLogItem.columnNames) }}</i> ist der Wert <i>{{ errorTransformationLogItem.objects }}</i> kein valides Geokoordinatensystem. Wählen Sie bitte DEZIMALGRAD oder UTM aus.
  </span>
}

@if (errorTransformationLogItem?.errorCode === 'GEOKOORDINATEN_FIELD_MISSING') {
  <span>
    In der Spalte <i>{{ formatArray(errorTransformationLogItem.columnNames) }}</i> fehlt ein Wert, um die Geokoordinate zu bestimmen.
  </span>
}

@if (errorTransformationLogItem?.errorCode === 'GEOKOORDINATEN_INVALID_FORMAT') {
  <span>
    In der Spalte <i>{{ formatArray(errorTransformationLogItem.columnNames) }}</i> stehen Werte für eine Geokoordinate, die nicht interpretiert werden können.
  </span>
}

@if (errorTransformationLogItem?.errorCode === 'GEOKOORDINATEN_NOT_IN_DEUTSCHLAND') {
  <span>
    In den Spalten <i>{{ formatArray(errorTransformationLogItem.columnNames) }}</i> stehen Werte für eine Geokoordinate, die sich nicht in Deutschland befindet.
  </span>
}

@if (errorTransformationLogItem?.errorCode === 'BRUTTO_NENNLEISTUNG_NOT_FOUND') {
  <span>
    Für die Spalte <i>{{ formatArray(errorTransformationLogItem.columnNames) }}</i> wurde kein Wert ermittelt.
  </span>
}

@if (errorTransformationLogItem?.errorCode === 'ABREGELMOEGLICHKEIT_INVALID_FOR_ENERGIETRAEGER') {
  <span>
    Für die Spalte <i>{{ formatArray(errorTransformationLogItem.columnNames) }}</i> ist der Wert
    <i>{{ errorTransformationLogItem.objects[0] }}</i> in Kombination mit dem Energieträger nicht gültig.
  </span>
}

@if (errorTransformationLogItem?.errorCode === 'DOKUMENTEN_ID_DUPLICATE') {
  <span>
    Der Wert <i>{{ errorTransformationLogItem.columnNames[0] }}</i> kollidiert mit Erzeugungsanlagen aus folgenden Zeilen: {{ errorTransformationLogItem.objects.join(', ')}}.
  </span>
}

@if (errorTransformationLogItem?.errorCode === 'DOKUMENTEN_ID_NOTFOUND') {
  <span>
    In der Spalte <i>{{ formatArray(errorTransformationLogItem.columnNames) }}</i> wurde eine ID (<i>{{ errorTransformationLogItem.objects }}</i>) gefunden, die nicht existiert.
    Wenn Sie diesen Datensatz neu anlegen wollen, löschen Sie bitte den Wert.
  </span>
}

@if (errorTransformationLogItem?.errorCode === 'FRE_REDUZIERUNG_INVALID') {
  <span>
    In der Spalte <i>{{ formatArray(errorTransformationLogItem.columnNames) }}</i> wurde der Wert nicht erkannt. Bitte verwenden Sie nur Werte aus der Auswahlliste.
  </span>
}

@if (errorTransformationLogItem?.errorCode === 'IEC101104_VALUES_MISSING') {
  <span>
    Beim Import der <i>IEC..101/104 Leitstellenkopplung</i> konnte für den Kopplungstyp <i>{{ formatArray(errorTransformationLogItem.objects) }}</i> kein Wert in der Spalte <i>{{ formatArray(errorTransformationLogItem.columnNames) }}</i> ermittelt werden.
    Es müssen immer alle Werte (alle drei Bytes und die Typkennung) gefüllt werden.
  </span>
}

@if (errorTransformationLogItem?.errorCode === 'IEC101104_ASDU_ADRESSE_MANDATORY') {
  <span>
    Beim Import der <i>IEC..101/104 Leitstellenkopplung</i> konnte kein Wert in der Spalte <i>{{ formatArray(errorTransformationLogItem.columnNames) }}</i> ermittelt werden. Die <i>Gemeinsame ASDU-Adresse</i> ist allerdings ein Pflichtfeld, wenn
    als Abregelungsart <i>IEC..101/104</i> eingestellt wurde.
  </span>
}

@if (errorTransformationLogItem?.errorCode === 'FRE_ANWENDERADRESSE_INVALID') {
  <span>
    Bei der <i>Abregelmöglichkeit FRE</i> sind nur vordefinierte Anwenderadressen (<i>{{ abregelungFREAnwenderadressen.join(', ')}}</i>) zulässig.
  </span>
}

@if (errorTransformationLogItem?.errorCode === 'TASE2_VALUES_MISSING') {
  <span>
    Beim Import der <i>TASE.2 Leitstellenkopplung</i> konnte für den Kopplungstyp <i>{{ formatArray(errorTransformationLogItem.objects) }}</i> kein Wert in der Spalte <i>{{ formatArray(errorTransformationLogItem.columnNames) }}</i> ermittelt werden. Es müssen immer das <i>TASE.2-Objekt</i> und der <i>Elementtyp</i> gefüllt sein.
  </span>
}

@if (errorTransformationLogItem?.errorCode === 'WRONG_TYPE_COMBINATION_TASE2') {
  <span>
    Beim Import der <i>TASE.2 Leitstellenkopplung</i> ist die Kombination der verschiedenen <i>Adressen</i> ungültig.
    <br>
      <br>
        Ist beispielsweise der Sollwert ausgefüllt, müssen die Typen 100,60,30 und 0 leer sein. Sind z.B. die Adressen für den Kopplungstyp 60 befüllt,
        so müssen auch mindestens die Werte für die Kopplungstypen 100 und 0 vollständig sein (unterschiedliche Kombinationen möglich).
        Orientieren Sie sich im Zweifel an dem Formular in der Weboberfläche.
      </span>
    }

    @if (errorTransformationLogItem?.errorCode === 'WRONG_TYPE_COMBINATION_REGELSTUFE_AND_TASE2_VALUES') {
      <span>
        Beim Import der <i>TASE.2 Leitstellenkopplung</i> ist die Kombination der ausgewählten <i>Regelstufe</i> mit den verschieden ausgefüllten Adressen ungültig.
        <br>
          <br>
            Ist beispielsweise eine Regelstufe 100,90,80,70,60,50,40,30,20,10,0 ausgefüllt, dürfen nur die Werte für den Sollwert gefüllt werden.
            Wird in Regelstufen z.B. 100,60,0 ausgewählt, müssen die Adressen 100,60,0 befüllt werden (unterschiedliche Kombinationen möglich).
            Orientieren Sie sich im Zweifel an dem Formular in der Weboberfläche.
          </span>
        }

        @if (errorTransformationLogItem?.errorCode === 'WRONG_TYPE_COMBINATION_IEC101104') {
          <span>
            Beim Import der <i>IEC..101/104 Leitstellenkopplung</i> ist die Kombination der verschiedenen <i>Adressen</i> ungültig.
            <br>
              <br>
                Ist beispielsweise der Sollwert ausgefüllt, müssen die Typen 100,60,30 und 0 leer sein. Sind z.B. die Adressen für den Kopplungstyp 60 befüllt,
                so müssen auch mindestens die Werte für die Kopplungstypen 100 und 0 vollständig sein (unterschiedliche Kombinationen möglich).
                Orientieren Sie sich im Zweifel an dem Formular in der Weboberfläche.
              </span>
            }

            @if (errorTransformationLogItem?.errorCode === 'WRONG_TYPE_COMBINATION_REGELSTUFE_AND_IEC101104_VALUES') {
              <span>
                Beim Import der <i>IEC..101/104 Leitstellenkopplung</i> ist die Kombination der ausgewählten <i>Regelstufe</i> mit den verschieden ausgefüllten Adressen ungültig.
                <br>
                  <br>
                    Ist beispielsweise eine Regelstufe 100,90,80,70,60,50,40,30,20,10,0 ausgefüllt, dürfen nur die Werte für den Sollwert gefüllt werden.
                    Wird in Regelstufen z.B. 100,60,0 ausgewählt, müssen die Adressen 100,60,0 befüllt werden (unterschiedliche Kombinationen möglich).
                    Orientieren Sie sich im Zweifel an dem Formular in der Weboberfläche.
                  </span>
                }

                @if (errorTransformationLogItem?.errorCode === 'IEC101104_TYPKENNUNG_INVALID') {
                  <span>
                    Beim Import der <i>IEC..101/104 Leitstellenkopplung</i> steht in der Spalte <i>{{ formatArray(errorTransformationLogItem.columnNames) }}</i> eine ungültige Typkennung.
                    Erlaubte Werte sind {{ formatArray(errorTransformationLogItem.objects) }}
                  </span>
                }

                @if (errorTransformationLogItem?.errorCode === 'REDISPATCH_RELEVANT_NON_PRESENT') {
                  <span>
                    In der Spalte <i>{{ formatArray(errorTransformationLogItem.columnNames) }}</i> wurde kein Wert ermittelt.
                  </span>
                }

                @if (errorTransformationLogItem?.errorCode === 'VERGUETUNGSART_UNKNOWN' || errorTransformationLogItem?.errorCode === 'ABRECHNUNGSKLASSE_UNKOWN') {
                  <span
                    >
                    In der Spalte <i>{{ formatArray(errorTransformationLogItem.columnNames) }}</i> muss ein gültiger Wert stehen, bitte wählen Sie einen vorgeschlagenen Wert aus der Auswahlliste aus.
                  </span>
                }

                @if (errorTransformationLogItem?.errorCode === 'SOLAR_ABSENKUNG70_INVALID') {
                  <span>
                    Die Werte in den Spalten <i>{{ formatArray(errorTransformationLogItem.columnNames) }}</i> stimmen nicht überein.
                  </span>
                }

                @if (errorTransformationLogItem?.errorCode === 'LEISTUNGSKLASSE_UNKNOWN' || errorTransformationLogItem?.errorCode === 'ENERGIEART_UNKNOWN') {
                  <span
                    >
                    In der Spalte <i>{{ formatArray(errorTransformationLogItem.columnNames) }}</i> muss ein gültiger Wert stehen, falls <i>FRE</i> als <i>Abregelmöglichkeit</i> ausgewählt wurde.
                  </span>
                }

                @if (errorTransformationLogItem?.errorCode === 'UNDETERMINED_BOOLEAN') {
                  <span>
                    In der Spalte <i>{{ formatArray(errorTransformationLogItem.columnNames) }}</i> sollte statt dem Wert <i>{{ errorTransformationLogItem.objects[0] }}</i>  ausschließlich <i>Ja</i>
                    oder <i>Nein</i> stehen. Bitte verwenden Sie nur Werte aus der Auswahlliste.
                  </span>
                }

                @if (errorTransformationLogItem?.errorCode === 'BEANVALIDATION_VIOLATION_KOPPLUNGSTYP') {
                  <span>
                    Das zum Abregelungstyp <i>{{ errorTransformationLogItem.columnNames[0] }}</i> gehörende Objekt <i>{{ errorTransformationLogItem.columnNames[1] }}</i> mit dem Wert <i>{{ errorTransformationLogItem.objects }}</i> entspricht nicht dem erforderlichen Muster.
                  </span>
                }

                @if (errorTransformationLogItem?.errorCode === 'BEANVALIDATION_VIOLATION_REDISPATCH_RELEVANT') {
                  <span>
                    Es müssen alle Redispatch relevanten Daten unter der Gruppierung <i>{{ errorTransformationLogItem.headerNames[0] }}</i> angegeben werden.
                  </span>
                }

                @if (errorTransformationLogItem?.errorCode === 'BEANVALIDATION_VIOLATION_REDISPATCH_FLAG_INVALID') {
                  <span>
                    Der Wert <i>{{ errorTransformationLogItem.columnNames[0] }}</i> ist ungültig. Bei Anlagen mit <i>Keine Regelung</i> oder <i>70%</i> als <i>Abregelmöglichkeit</i> darf die Anlage NICHT Redispatch relevant sein.
                    Bei allen anderen Optionen der <i>Abregelmöglichkeit</i> MUSS die Anlage Redispatch relevant sein.
                  </span>
                }

                @if (errorTransformationLogItem?.errorCode === 'BEANVALIDATION_VIOLATION_REDISPATCH_FLAG_REQUIRED_FALSE') {
                  <span>
                    Der Wert <i>{{ errorTransformationLogItem.columnNames[0] }}</i> ist ungültig. Es sind nur Anlagen zulässig, die NICHT Redispatch relevant sind. (Aufgrund DL)
                  </span>
                }

                @if (errorTransformationLogItem?.errorCode === 'BEANVALIDATION_VIOLATION_ABREGELMOEGLICHKEIT') {
                  <span>
                    Bei einer Anlagen ab einer <i>Brutto-Nennleistung</i> von 100 kW sind <i>Keine Regelung</i> oder <i>70%</i> als <i>Abregelmöglichkeit</i> KEINE gültigen Werte.
                  </span>
                }

                @if (errorTransformationLogItem?.errorCode === 'BEANVALIDATION_VIOLATION_STEUERGRUPPE_ID_MUST_BE_NULL') {
                  <span>
                    Der Wert <i>{{ errorTransformationLogItem.columnNames[0] }}</i> muss leer sein bei Anlagen mit <i>Keine Regelung</i> oder <i>70%</i> als <i>Abregelmöglichkeit</i>.
                  </span>
                }

                @if (errorTransformationLogItem?.errorCode === 'BEANVALIDATION_VIOLATION_STEUERGRUPPE_ID_NETZZUORDNUNG_INVALID') {
                  <span>
                    Der Wert <i>{{ errorTransformationLogItem.columnNames[0] }}</i> ist bereits einer anderen <i>Netzzuordnung</i> zugewiesen.
                  </span>
                }

                @if (errorTransformationLogItem?.errorCode === 'BEANVALIDATION_VIOLATION_STEUERBARE_RESOURCE_NETZZUORDNUNG_INVALID') {
                  <span>
                    Bei Anlagen mit gleicher <i>{{ errorTransformationLogItem.columnNames[0] }}</i> müssen die Steuerinformationen und die Netzzuordnung gleich sein. Bei gleichen Steuerinformationen muss die <i>{{ errorTransformationLogItem.columnNames[0] }}</i> und die Netzzuordnung gleich sein. Es bestehen Konflikte mit Erzeugungsanlagen aus folgenden Zeilen: {{ errorTransformationLogItem.objects.join(', ')}}.
                  </span>
                }

                @if (errorTransformationLogItem?.errorCode === 'BEANVALIDATION_VIOLATION_STEUERBARE_RESOURCE_ID_REQUIRED') {
                  <span>
                    Der Wert <i>{{ errorTransformationLogItem.columnNames[0] }}</i> muss gefüllt sein bei der vorliegenden <i>Abregelmöglichkeit</i>.
                  </span>
                }

                @if (errorTransformationLogItem?.errorCode === 'BEANVALIDATION_VIOLATION_STEUERBARE_RESOURCE_ID_MUST_BE_NULL') {
                  <span>
                    Der Wert <i>{{ errorTransformationLogItem.columnNames[0] }}</i> muss leer sein bei Anlagen mit <i>Keine Regelung</i> oder <i>70%</i> als <i>Abregelmöglichkeit</i>.
                  </span>
                }

                @if (errorTransformationLogItem?.errorCode === 'BEANVALIDATION_VIOLATION_TECHNISCHE_RESOURCE_ID_REQUIRED') {
                  <span>
                    Der Wert <i>{{ errorTransformationLogItem.columnNames[0] }}</i> muss gefüllt sein bei der vorliegenden <i>Abregelmöglichkeit</i>.
                  </span>
                }

                @if (errorTransformationLogItem?.errorCode === 'BEANVALIDATION_VIOLATION_TECHNISCHE_RESOURCE_ID_NOT_UNIQUE') {
                  <span>
                    In der Spalte <i>{{ errorTransformationLogItem.columnNames[0] }}</i> ist eine bereits vergebene Technische Ressource ID angegeben.
                  </span>
                }

                @if (errorTransformationLogItem?.errorCode === 'BEANVALIDATION_VIOLATION_SOLAR_ALIGNMENT') {
                  <span>
                    Der Wert <i>{{ errorTransformationLogItem.columnNames[0] }}</i> muss angegeben werden, da als Abrechnungsmodell Spitz bzw. Spitz/Light ausgewählt wurde.
                  </span>
                }

                @if (errorTransformationLogItem?.errorCode === 'WRONG_TYPE_REGELSTUFE_TO_ABREGELMOEGLICHKEIT') {
                  <span>
                    Das Feld <i>{{ errorTransformationLogItem.columnNames[0] }}</i> enthielt keinen oder einen falschen Wert. Dieser ist nicht gültig in Kombination mit dem hinterlegten Wert im Feld <i>{{ errorTransformationLogItem.columnNames[1] }}</i>.
                  </span>
                }

                @if (errorTransformationLogItem?.errorCode === 'BEANVALIDATION_VIOLATION_WIND_ANLAGENKENNLINIE') {
                  <span>
                    Unter der Gruppierung <i>{{ errorTransformationLogItem.headerNames[0] }}</i> müssen mindestens 15 Werte größer als 1 angegeben werden.
                  </span>
                }

                @if (errorTransformationLogItem?.errorCode === 'BEANVALIDATION_VIOLATION_BATTERIE_LEISTUNG_INFO_MISSING') {
                  <span>
                    Da es sich um ein Batteriespeicher handelt, muss unter der Gruppierung <i>{{ errorTransformationLogItem.headerNames[0] }}</i> für <i>{{ errorTransformationLogItem.columnNames[0] }}</i> ein Wert angegeben werden.
                  </span>
                }

                @if (errorTransformationLogItem?.errorCode === 'BEANVALIDATION_VIOLATION_ENERGIETRAEGER_SPECIFIC') {
                  <span>
                    Unter der Gruppierung <i>{{ errorTransformationLogItem.headerNames[0] }}</i> sind Werte hinterlegt, die bei diesem Energieträger ungültig sind.
                  </span>
                }

                @if (errorTransformationLogItem?.errorCode === 'BEANVALIDATION_VIOLATION_ANLAGENSCHLUESSEL') {
                    @if (errorTransformationLogItem?.constraint === 'AnlagenschluesselConstraint_NotNull') {
                      <span>
                        In der Spalte <i>{{ errorTransformationLogItem.columnNames[0] }}</i> wurde kein Wert ermittelt, ist bei EEG-Anlagen jedoch erforderlich.
                      </span>
                    } @else {
                      <span>
                        Der Wert <i>{{ errorTransformationLogItem.columnNames[0] }}</i> ist ungültig. Bei der Auswahl KWKG/Sonstiges im Feld Fördermodell darf der Anlagenschlüssel maximal 33 Zeichen lang sein. Für EEG-Anlagen muss das Muster des Anlagenschlüssels entsprechend der Hinweise für Netzbetreiber gemäß BDEW-Umsetzungshilfe eingehalten werden.
                      </span>
                    }
                }

                @if (errorTransformationLogItem?.errorCode === 'BEANVALIDATION_VIOLATION_ANLAGENSCHLUESSEL_NOT_UNIQUE') {
                    <span>
                      Der Wert <i>{{ errorTransformationLogItem.columnNames[0] }}</i> ist ein bereits vergebener Anlagenschlüssel.
                    </span>
                }

                @if (errorTransformationLogItem?.errorCode === 'BEANVALIDATION_VIOLATION_ABRECHNUNGSMODELL_SPITZ_LIGHT') {
                  <span>
                    @if (errorTransformationLogItem?.constraint === 'AbrechnungsmodellSpitzLightConstraint') {
                      <span>
                        In der Spalte <i>{{ formatArray(errorTransformationLogItem.columnNames) }}</i> wurde kein Wert ermittelt.
                      </span>
                    }
                    @if (errorTransformationLogItem?.constraint === 'AbrechnungsmodellSpitzLightConstraint_NotNull') {
                      <span>
                        In der Spalte <i>{{ formatArray(errorTransformationLogItem.columnNames) }}</i> wurde kein Wert ermittelt.
                      </span>
                    }
                    @if (errorTransformationLogItem?.constraint === 'AbrechnungsmodellSpitzLightConstraint_ShouldBeNull') {
                      <span>
                        In der Spalte <i>{{ formatArray(errorTransformationLogItem.columnNames) }}</i> darf kein Wert stehen.
                      </span>
                    }
                  </span>
                }

                @if (errorTransformationLogItem?.errorCode === 'BEANVALIDATION_VIOLATION_BACKEND_MESSAGE') {
                  <span>
                    @if (errorTransformationLogItem?.constraint === 'Pattern') {
                      <span>
                        In der Spalte <i>{{ formatArray(errorTransformationLogItem.columnNames) }}</i> gibt es einen Fehler mit dem Wert <i>{{ errorTransformationLogItem.objects }}</i>. {{ errorTransformationLogItem.message }}
                      </span>
                    }
                  </span>
                }

                @if (errorTransformationLogItem?.errorCode === 'BEANVALIDATION_VIOLATION_TRANCHE') {
                  <span>
                    Unter der Gruppierung <i>{{ errorTransformationLogItem.headerNames[0] }}</i> sind Werte hinterlegt, daher muss auch unter <i>{{ formatArray(errorTransformationLogItem.columnNames) }}</i> ein Wert hinterlegt werden.
                  </span>
                }

                @if (errorTransformationLogItem?.errorCode === 'BEANVALIDATION_VIOLATION') {
                  <span>
                    @if (errorTransformationLogItem?.constraint === 'Pattern') {
                      <span>
                        In der Spalte <i>{{ formatArray(errorTransformationLogItem.columnNames) }}</i> entspricht der Wert <i>{{ errorTransformationLogItem.objects }}</i> nicht dem erforderlichen Muster.
                      </span>
                    }
                    @if (errorTransformationLogItem?.constraint === 'Size' || errorTransformationLogItem?.constraint === 'Digits' || errorTransformationLogItem?.constraint === 'Length') {
                      <span
                        >
                        In der Spalte <i>{{ formatArray(errorTransformationLogItem.columnNames) }}</i> ist der Wert länger als der maximal zulässige.
                      </span>
                    }
                    @if (errorTransformationLogItem?.constraint === 'DecimalMax' || errorTransformationLogItem?.constraint === 'Max') {
                      <span
                        >
                        In der Spalte <i>{{ formatArray(errorTransformationLogItem.columnNames) }}</i> liegt der Wert <i>{{ errorTransformationLogItem.objects }}</i> über dem maximal zulässigen.
                      </span>
                    }
                    @if (errorTransformationLogItem?.constraint === 'DecimalMin' || errorTransformationLogItem?.constraint === 'Min') {
                      <span
                        >
                        In der Spalte <i>{{ formatArray(errorTransformationLogItem.columnNames) }}</i> liegt der <i>{{ errorTransformationLogItem.objects }}</i> unter der minimal zulässigen.
                      </span>
                    }
                    @if (errorTransformationLogItem?.constraint === 'NotNull' || errorTransformationLogItem?.constraint === 'NotBlank' || errorTransformationLogItem?.constraint === 'NotEmpty') {
                      <span
                        >
                        In der Spalte <i>{{ formatArray(errorTransformationLogItem.columnNames) }}</i> wurde kein Wert ermittelt.
                      </span>
                    }
                    @if (errorTransformationLogItem?.constraint === 'MarktpartnerConstraint') {
                      <span>
                        In der Spalte <i>{{ formatArray(errorTransformationLogItem.columnNames) }}</i> sind eine oder mehrere ungültige Marktpartner-ID's angegeben.
                      </span>
                    }
                    @if (errorTransformationLogItem?.constraint === 'MarktlokationTrancheConstraint') {
                      <span>
                        In der Spalte <i>{{ formatArray(errorTransformationLogItem.columnNames) }}</i> wurde kein Wert ermittelt.
                      </span>
                    }
                    @if (errorTransformationLogItem?.constraint === 'ResourceIdConstraint') {
                      <span>
                        In der Spalte <i>{{ formatArray(errorTransformationLogItem.columnNames) }}</i> ist die Prüfsumme (nach Bildungsvorschrift des BDEW) nicht korrekt.
                      </span>
                    }
                    @if (errorTransformationLogItem?.constraint === 'MarktlokationIdConstraint') {
                      <span>
                        In der Spalte <i>{{ formatArray(errorTransformationLogItem.columnNames) }}</i> ist die Prüfsumme (nach Bildungsvorschrift des BDEW) nicht korrekt.
                      </span>
                    }
                    @if (errorTransformationLogItem?.constraint === 'EicCodeConstraint') {
                      <span>
                        In der Spalte <i>{{ formatArray(errorTransformationLogItem.columnNames) }}</i> ist der EIC-Code ungültig.
                      </span>
                    }
                    @if (errorTransformationLogItem?.constraint === 'EicCodeConstraint_EicToShort') {
                      <span>
                        In der Spalte <i>{{ formatArray(errorTransformationLogItem.columnNames) }}</i> ist der EIC-Code zu kurz.
                      </span>
                    }
                    @if (errorTransformationLogItem?.constraint === 'EicCodeConstraint_EicToLong') {
                      <span>
                        In der Spalte <i>{{ formatArray(errorTransformationLogItem.columnNames) }}</i> ist der EIC-Code zu lang.
                      </span>
                    }
                    @if (errorTransformationLogItem?.constraint === 'EicCodeConstraint_ContainsInvalidChar') {
                      <span>
                        In der Spalte <i>{{ formatArray(errorTransformationLogItem.columnNames) }}</i> enthält der EIC-Code unzulässige Zeichen.
                      </span>
                    }
                    @if (errorTransformationLogItem?.constraint === 'EicCodeConstraint_InvalidChecksum') {
                      <span>
                        In der Spalte <i>{{ formatArray(errorTransformationLogItem.columnNames) }}</i> ist die Prüfsumme (nach Bildungsvorschrift des BDEW) nicht korrekt.
                      </span>
                    }
                    @if (errorTransformationLogItem?.constraint === 'PostalCodeConstraint') {
                      <span>
                        In der Spalte <i>{{ formatArray(errorTransformationLogItem.columnNames) }}</i> ist die Postleitzahl ungültig.
                      </span>
                    }
                    @if (errorTransformationLogItem?.constraint === 'PostalCodeConstraint_InvalidGermanPostalCode') {
                      <span>
                        In der Spalte <i>{{ formatArray(errorTransformationLogItem.columnNames) }}</i> ist die Postleitzahl ungültig. Bitte geben Sie eine Postleitzahl aus Deutschland an.
                      </span>
                    }
                    @if (errorTransformationLogItem?.constraint === 'PostalCodeConstraint_InvalidOtherPostalCode') {
                      <span>
                        In der Spalte <i>{{ formatArray(errorTransformationLogItem.columnNames) }}</i> ist die Postleitzahl ungültig. Sie können eine 3 bis 8-stellige Postleitzahl eingeben. Internationale Postleitzahlen sind möglich.
                      </span>
                    }
                    @if (errorTransformationLogItem?.constraint === 'DateConstraint') {
                      <span>In der Spalte <i>{{ formatArray(errorTransformationLogItem.columnNames) }}</i> ist das Datum ungültig.</span>
                      <span>
                        @switch (errorTransformationLogItem?.message) {
                          @case ('BEFORE_TODAY') {
                            Das Datum is heute oder liegt in der Zukunft. Daten in der Zukunft können Sie nicht erfassen.
                          }
                          @case ('BEFORE_TODAY_INCLUDING_TODAY') {
                            Das Datum liegt in der Zukunft. Daten in der Zukunft können Sie nicht erfassen.
                          }
                          @case ('AFTER_TODAY_INCLUDING_TODAY') {
                            Das Datum liegt in der Vergangenheit. Daten aus der Vergangenheit können Sie nicht erfassen.
                          }
                          @case ('AFTER_TODAY') {
                            Das Datum is heute oder liegt in der Vergangenheit. Daten aus der Vergangenheit können Sie nicht erfassen.
                          }
                        }
                      </span>
                    }
                    @if (errorTransformationLogItem?.constraint === 'FunkrundsteuerEmpfaengerInformationenFWARequiredFieldsConstraint') {
                      <span
                        >
                        Wenn <i>FWA</i> als <i>Abregelmöglichkeit</i> gewählt wurde, müssen die Spalten
                        <i>Id des Fernwirkgeräts (FWA)</i> mit gültigen Werten belegt sein.
                      </span>
                    }
                    @if (errorTransformationLogItem?.constraint === 'FunkrundsteuerEmpfaengerInformationenFRERequiredFieldsConstraint') {
                      <span
                        >
                        Wenn <i>FRE</i> als <i>Abregelmöglichkeit</i> gewählt wurde, müssen die Spalten
                        <i>Postleitzahl, Anwenderadresse, Id des Fernwirkgeräts (FRE), Energieart</i> und <i> Funkrundsteuerempfängerleistungsklasse</i>
                        mit gültigen Werten belegt sein.
                      </span>
                    }
                    @if (errorTransformationLogItem?.constraint === 'FunkrundsteuerEmpfaengerInformationenTase2RequiredFieldsConstraint') {
                      <span
                        >
                        Wenn <i>TASE.2</i> als <i>Abregelmöglichkeit</i> gewählt wurde, müssen die Spalten
                        <i>Verbindendes TASE.2-Objekt</i> mit gültigen Werten belegt sein.
                      </span>
                    }
                    <!-- Fehlermeldungen zu Regelstufen -->
                    @if (errorTransformationLogItem?.constraint === 'RegelstufenConstraint') {
                      <span>
                        Wenn <i>70%</i> als <i>Abregelmöglichkeit</i> gewählt wurde, muss die Regelstufe <i>70,70</i> ausgewählt werden.
                      </span>
                    }
                    @if (errorTransformationLogItem?.constraint === 'RegelstufenConstraint') {
                      <span>
                        Wenn <i>FRE</i> als <i>Abregelmöglichkeit</i> gewählt wurde, darf die Regelstufe <i>100,90,80,70,60,50,40,30,20,10,0</i> nicht ausgewählt werden.
                      </span>
                    }
                    @if (errorTransformationLogItem?.constraint === 'RegelstufenConstraint') {
                      <span>
                        Wenn <i>Abregelmöglichkeit</i> gewählt wurde, ist die Spalte <i>Regelstufen</i> auszufüllen.
                      </span>
                    }
                  </span>
                }


